import "../elements/checkbox-collapse";
import "../elements/cookie-consent";
import "../elements/countdown-block";
import "../elements/donation-customer-type";
import "../elements/mobile-nav";
import "../elements/multi-select";
import "../elements/nav-tree";
import "../elements/payment-type-collapse";
import "../elements/progress-button";
import "../elements/radio-button-list-collapse";
import "../elements/scroll-to-top";
import "../elements/select-collapse";
import "../elements/swish-payment";
import "../elements/textarea-maxlength";
import "../elements/theme-switcher";
import "../elements/validation-form";

import "../validation/organisationnumber";
import "../validation/requiredif";
import "../validation/requiredifmultivalue";
import "../validation/requiredtrue";
import "../validation/validation";
import "../validation/requiredgroup";
import "../validation/zipcode";

import "./analytics";
import "./shame";

// HTML has loaded
document.addEventListener("DOMContentLoaded", () => {

    document.querySelector("#cookie-consent")?.addEventListener("CookieConsent.save", (e) => {
        const dataLayer = "dataLayer" in window ? window["dataLayer"] : [];

        dataLayer.push({
            'event': 'cookie_approval',
            'cookie-statistics': e.detail.includes("statistics")
        });
    });

}, false);

// Images, etc has loaded
window.addEventListener("load", () => {

    // Add code here

});